export default {"src":"/_next/static/media/hand-holding-star-classic-solid.cce960a6.svg","height":24,"width":24};